import Casque from '@assets/images/icons/Icon-EPI-Casque-protection.svg';
import Chaussures from '@assets/images/icons/Icon-EPI-Chaussures-de-sécurité.svg';
import Gants from '@assets/images/icons/Icon-EPI-Gants-de-protection.svg';
import Lunettes from '@assets/images/icons/Icon-EPI-Lunettes-de-protection.svg';
import Casque_oreilles from '@assets/images/icons/Icon-EPI-Protection-auditive.svg';
import Vetements from '@assets/images/icons/Icon-EPI-Gilet-haute-visibilité.svg';
import Masque from '@assets/images/icons/Icon-EPI-Masque-de-protection.svg';

export default {
    Chaussures: {
        title: 'Chaussures de sécurité hautes',
        description: "Protègent les pieds contre les chutes d'objets, chocs, écrasements, perforations et glissements.",
        image: Chaussures
    },
    Gants: {
        title: 'Gants de protection',
        description: 'Protègent les mains contre les coupures, brûlures, abrasions et contacts avec les produits chimiques.',
        image: Gants
    },
    Casque_oreilles: {
        title: 'Protection auditive',
        description:
            "Protège l'audition contre les bruits excessifs et permanents/répétitifs liés à l'utilisation d'outils ou de machines, ou liés aux bruits ambiants du chantier.",
        image: Casque_oreilles
    },
    Masque: {
        title: 'Masque de protection',
        description: 'Protège contre des inhalations de produit chimique et de poussière.',
        image: Masque
    },
    Casque: {
        title: 'Casque de sécurité avec jugulaire attachée',
        description: "Protège la tête contre les chutes d'objets et les chocs.",
        image: Casque
    },
    Lunettes: {
        title: 'Protections oculaires',
        description: "Protègent les yeux contre les projections de produits chimiques, de poussières, et d'éclats.",
        image: Lunettes
    },
    Vetements: {
        title: 'Vêtements de travail adaptés',
        description: "Protège le corps d'agressions mécaniques.",
        image: Vetements
    }
};
